/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".no-content-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%}.no-content-wrapper .no-content-tip{-webkit-box-flex:1;-ms-flex:1;flex:1;color:#d3d3d3;font-size:60px;font-weight:700;text-align:center;width:100%}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/no.content.tip/no.content.component.scss.ngstyle.js.pre-build-optimizer.js